import React from "react";
import PropTypes from "prop-types";
import BondObligeeInformationBase from "../../../../features/bonds/shared/components/BondObligeeInformationBase";
import { getObligeeSurfaceConfig } from "../../../../features/bonds/shared/obligeeInformationConfig";

const BlanketObligeeInformation = ({ GoogleAutoComplete, ...props }) => (
  <BondObligeeInformationBase
    cfg={getObligeeSurfaceConfig("blanket", { hideAddWhenDisabled: true })}
    GoogleAutoComplete={GoogleAutoComplete}
    {...props}
  />
);

BlanketObligeeInformation.propTypes = {
  isDisabled: PropTypes.bool,
  control: PropTypes.object.isRequired,
  obligees: PropTypes.array,
  loadingObligees: PropTypes.bool,
  watch: PropTypes.func.isRequired,
  openObligeeDialog: PropTypes.bool.isRequired,
  setOpenObligeeDialog: PropTypes.func.isRequired,
  newObligee: PropTypes.object.isRequired,
  setNewObligee: PropTypes.func.isRequired,
  handleObligeeGoogleCallback: PropTypes.func.isRequired,
  GoogleAutoComplete: PropTypes.elementType.isRequired,
  allCities: PropTypes.array,
  allStates: PropTypes.array,
  handleAddObligee: PropTypes.func.isRequired,
};

export default BlanketObligeeInformation;
